import styled from 'styled-components'

export const Brand = styled.div`
	align-items: flex-start;
	display: flex;
	flex-direction: column;
	gap: 2px;
`
